import React from 'react';
import { motion } from 'framer-motion';
import software1 from '../Assets/software1.PNG';
import software2 from '../Assets/software33.PNG';

const Software = () => {
  const imageVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        delay: index * 0.3,
        ease: 'easeOut',
      },
    }),
  };

  const textVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        delay: index * 0.3,
        ease: 'easeOut',
      },
    }),
  };
  return (
     <div className="gestion-batiments-wrapper">
          <div className="gestion-batiments-container">
             <h1 className="simple-title"> Software</h1>
            
            <div className="imagebatiment">
              <div className="solution-content">
                {[
                  {
                    image: software1,
                    alt: 'software1',
                    description:
                      'Nous proposons des solutions logicielles adaptées aux environnements industriels pour faciliter la gestion, le suivi et l’optimisation des opérations. Intuitifs et évolutifs, nos logiciels permettent d’améliorer la productivité, de centraliser les données techniques et de renforcer la prise de décision.',
                    reverse: false,
                  },
                  {
                    image: software2,
                    alt: 'software2',
                    description:
                      'Améliorez la sécurité et le confort des occupants grâce à des systèmes intelligents de contrôle d’accès, de climatisation et d’éclairage automatisé.',
                    reverse: true,
                  },
                ].map((block, index) => (
                  <div key={index} className={`solution-block ${block.reverse ? 'reverse' : ''}`}>
                    <motion.div
                      className="solution-block-image-container"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      variants={imageVariants}
                      custom={index}
                    >
                      <img src={block.image} alt={block.alt} className="solution-block-image" />
                    </motion.div>
                    <motion.div
                      className="solution-block-text-container"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      variants={textVariants}
                      custom={index}
                    >
                      <p className="solution-block-description">{block.description}</p>
                    </motion.div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
   
  )
}

export default Software
